var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIconColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.1,
    height: 18,
    viewBox: "0 0 17.1 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "home_6_",
    "data-name": "home (6)",
    d: "M12.608,17.15H11.022a1.827,1.827,0,0,1-1.775-1.816V12.817a.348.348,0,0,0-.353-.343H6.548a.349.349,0,0,0-.348.343v2.509a.823.823,0,0,1-.028.214A1.827,1.827,0,0,1,4.359,17.15H2.792A3.641,3.641,0,0,1-.85,13.519V6.389s0-.005,0-.008a2.785,2.785,0,0,1,1.1-2.2L5.573-.109l0,0a3.391,3.391,0,0,1,4.223,0l5.354,4.29a2.8,2.8,0,0,1,1.1,2.192s0,.007,0,.011v7.138A3.641,3.641,0,0,1,12.608,17.15Z",
    transform: "translate(0.85 0.85)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconColor);
export default __webpack_public_path__ + "static/media/home_icon_color.cbaabcb116011b24e4a9d3e9c1ea3b0e.svg";
export { ForwardRef as ReactComponent };